import React from 'react';
import { TrustedByContentfulModel } from 'src/api/models/TrustedBy';
import TrustedByLogos from 'src/molecules/trustedBy/trustedByLogos';

export default function getDynamicTrustedBy(trustedByProps: TrustedByContentfulModel): React.ReactNode {
  return <TrustedByLogos logos={trustedByProps.contentfulchildren} />;
}
